import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import className from 'classnames';
import styles from './styles.css';
import FieldAccordion from '../FieldAccordion';
import FieldControls from '../FieldControls';
import FieldLabel from '../FieldLabel';
import FieldTypeSelector from '../FieldTypeSelector';

function FieldGroupAccordion({
  fields,
  snapshot,
  draggableProvided,
  fieldName,
  fieldIndex,
}) {
  const usePortal = snapshot.isDragging;

  const AccordionElement = (
    <div
      ref={draggableProvided.innerRef}
      {...draggableProvided.draggableProps}
      className={className(styles.SectionAccordionWrapper, {
        [`${styles['SectionAccordionWrapper--dragging']}`]: snapshot.isDragging,
      })}
      role="button"
    >
      <FieldAccordion
        key={`${fieldName}-${fieldIndex}`}
        id={`${fieldName}-field-group-accordion-${fieldIndex}`}
        fieldName={fieldName}
        fieldData={fields.value[fieldIndex]}
        index={fieldIndex}
        dragHandleProps={draggableProvided.dragHandleProps}
        closedByDefault
      >
        <FieldControls
          fieldData={fields.value[fieldIndex]}
          fieldName={fieldName}
        />
        <FieldLabel
          fieldData={fields.value[fieldIndex]}
          fieldName={fieldName}
        />
        <FieldTypeSelector
          fieldName={fieldName}
          fieldData={fields.value[fieldIndex]}
        />
      </FieldAccordion>
    </div>
  );

  if (!usePortal) {
    return AccordionElement;
  }

  const container = document.getElementById('OverlayContainer');
  return ReactDOM.createPortal(AccordionElement, container);
}

FieldGroupAccordion.propTypes = {
  fields: PropTypes.object,
  fieldName: PropTypes.string,
  fieldIndex: PropTypes.number,
  snapshot: PropTypes.object,
  draggableProvided: PropTypes.object,
};

export default FieldGroupAccordion;
